import React, { Component } from 'react'
import { connect } from "react-redux";
import { Button } from 'reactstrap';
import { Helmet } from 'react-helmet-async';
import IconButton from '@mui/material/IconButton';
import MUIDataTable from "mui-datatables";

import moment from 'moment';

import { NotificationManager } from 'react-notifications';

// intl messages
import IntlMessages from 'Util/IntlMessages';
// page title bar
import PageTitleBar from 'Components/PageTitleBar/PageTitleBar';
// app config
import AppConfig from 'Constants/AppConfig';

import AddMSKElement from './component/addmsk';
import EditMSKElement from './component/editmsk';
import ConfirmationDialog from "Routes/common/ConfirmationDialog";
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import DeleteOutlineOutlinedIcon from '@mui/icons-material/DeleteOutlineOutlined';

import {
   allMskAssessment,
   allStudents,
   checkMskAssessment,
   addMskAssessment,
   fetchMskAssessment,
   editMskAssessment,
   deleteMskAssessment
} from 'Actions';

// rct card box
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';

class mskassessment extends Component {
   
   constructor(props) {
      
      super(props);
      this.confirmationDialog = React.createRef();
         this.state = {
            student: '',
            quarter:'',
            seldate:'',
            actionvalue:'',
            viewdiv:true,
            adddiv:false,
            addinnerdiv:true,
            editdiv:false,
            
         };      
         
      
      this.onBackSection = this.onBackSection.bind(this);      
      this.editAssessment = this.editAssessment.bind(this);
      this.deleteAssessment = this.deleteAssessment.bind(this);
   }

   UNSAFE_componentWillMount() {
		this.props.allMskAssessment();
	}

   onBackSection() {
		this.setState({ adddiv:false,
         editdiv:false,
         viewdiv:true });
	}

   onAddSession() {
		this.setState({ 
         viewdiv:false,
         editdiv:false,
         adddiv:true
          });
	}

   selectdate = (date) => {
      const seldate =moment(new Date(date)).format('yyyy-MM-DD');
      this.setState({ seldate:date });
      var student =this.state.student;
      var quater =this.state.quarter;
      this.props.checkMskAssessment(student, seldate, quater).then((data) => {         
          if(data.status==1){
            this.setState({ 
               addinnerdiv:true
            });
          }else{
            NotificationManager.error('An assessment already exists for this date, try creating for different date.');
            
            this.setState({ 
               addinnerdiv:false
            });
          }
       })
       .catch((e) => {
         console.log(e);
       });  
      
   }

   
   editAssessment(rowdata){

      this.props.fetchMskAssessment(rowdata).then((data) => {   
         var resdata=data.data;
         
         this.setState({ 
            viewdiv:false,
            adddiv:false,
            editdiv:true
             });
      });
      
   }

   deleteAssessment(pa_id) {
      this.id = pa_id;
      this.confirmationDialog.current.openDialog();
   }

   deleteDataPermanent(popupResponse) {

      if (popupResponse) {
         this.props.deleteMskAssessment(this.id);
         this.data = ""
      }
   }

    render() {
      const { match, assessmentlists, studentlists, loading, actionstatus, mskresponse } = this.props;
       
      const allstudent=studentlists.map((stdval) => {  
            return {
               label: stdval.student,  
               value: stdval.uudID
            }
      });

      const options = {
			filterType: 'dropdown',
         rowsPerPage: 50,
         responsive:'standard',
         rowsPerPageOptions: [50, 100, 150],
         selectableRowsHideCheckboxes: true,
		};

      const columns = [
         { name: "no", label: "No" },
         { name: "name", label: "Name" },
         { name: "assessment", label: "Assessment No" },
         { name: "date", label: "Date" },
         { name: "edit", label: "Edit" },
         { name: "delete", label: "Delete" }
       ];
      const tabledata=assessmentlists.map((assmntval,idx) => {            
         
            const ebtn=<IconButton className='text-info' onClick={ ()=>this.editAssessment(assmntval)}><EditOutlinedIcon/></IconButton>;
            const dbtn=<IconButton className="text-danger" aria-label="Delete" onClick={ ()=>this.deleteAssessment(assmntval.pa_id)}><DeleteOutlineOutlinedIcon/></IconButton>;
            
            return {
               no:idx+1,
               name: assmntval.student,
               assessment: assmntval.quarter,
               date: assmntval.cdate,
               edit: ebtn,
               delete:dbtn
            }
      });
      const studentname=mskresponse.student;
       return (
          <div className="saas-dashboard">
             <Helmet>
                <title>MSK Assessments | {AppConfig.appTitle}</title>
                <meta name="description" content="Reactify Sass Dashboard" />
             </Helmet>
             <PageTitleBar title={<IntlMessages id="sidebar.mskassessmentheading" />} match={match} />
             <div className="row">
               {this.state.viewdiv && 
                  <div className="col-sm-12 col-lg-8" style={{margin:"0 auto"}}>
                     <RctCollapsibleCard heading="List" fullBlock>
                        <MUIDataTable
                              title={<div><Button onClick={ ()=>this.onAddSession()} className="btn btn-outline-info"><i className="zmdi zmdi-plus-circle-o"></i>  Create Assessment</Button></div>}
                              data={tabledata}
                              columns={columns}
                              options={options} 
                        />   
                     </RctCollapsibleCard>
                  </div>  
               }
            </div>
               {this.state.adddiv && 
                  <AddMSKElement onClick={this.onBackSection}/>
               }

               {this.state.editdiv && 
                  <EditMSKElement onClick={this.onBackSection} data={this.state}/>
               }

             <ConfirmationDialog
                ref={this.confirmationDialog}
                onConfirm={(res) => this.deleteDataPermanent(res)}
                data={'Record'}
             />
             
          </div>
       )
    }
 }


const mapStateToProps = ({mskassessment, mostlyused}) => {                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                        
	const { assessmentlists, loading, actionstatus, mskresponse } = mskassessment;
   const { studentlists } = mostlyused;
	return { assessmentlists, studentlists, loading, actionstatus, mskresponse };
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                           
}

export default connect(mapStateToProps, {
   allMskAssessment,
   allStudents,
   checkMskAssessment,
   addMskAssessment,
   fetchMskAssessment,
   editMskAssessment,
   deleteMskAssessment
})(mskassessment); 